import React from "react";
import ReactSelect from "react-select";

type Props = {
  options: any;
  label: string;
  value: any;
  setValue: any;
};

const Select: React.FC<Props> = ({ options, label, value, setValue }) => {
  return (
    <div
      style={{
        flexDirection: "row",
        display: "flex",
        alignItems: "center",
        marginRight: 48
      }}
    >
      <h5 style={{ marginRight: 8 }}>{label} </h5>
      <ReactSelect
        options={options}
        value={value}
        onChange={setValue}
        styles={{
          control: ({ ...css }: any) => ({
            ...css,
            
            width: 200,
          }),
          menu: ({ width, ...css }: any) => ({
            ...css,
            width: "max-content",
            color: 'black',
            minWidth: "100%",
          }),
        }}
      />
    </div>
  );
};

export { Select };
